// ─── Statistiques de garde — calculs PURS ──────────────────────────
// Porté de MoPCal (`services/statsGarde.js`). Entrée : un `parJour`
// { 'YYYY-MM-DD': 'parent1'|'parent2' } — celui que renvoie
// `calculerGardePeriode` (garde CALCULÉE, priorité surcharge > vacances >
// rythme), PAS le planning brut stocké : la suite calcule la garde des jours
// sans surcharge (rythmes, vacances) alors que MoPCal l'écrivait en base.
// Utiliser le planning brut sous-compterait presque tous les jours.
// Aucun accès réseau ici — module pur, testable.

export const PERIODES_STATS = [
  { id: '30j', jours: 30 },
  { id: '3m',  jours: 90 },
  { id: '6m',  jours: 180 },
  { id: '12m', jours: 365 },
];

const pad = (n) => String(n).padStart(2, '0');
const dk = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

// Bornes d'une période finissant AUJOURD'HUI.
export function bornesPeriode(jours) {
  const fin = new Date(); fin.setHours(0, 0, 0, 0);
  const debut = new Date(fin); debut.setDate(debut.getDate() - (Math.max(1, jours) - 1));
  return { debut: dk(debut), fin: dk(fin) };
}

// Compte les jours de garde sur [debut, fin] (inclus). Ne compte que les
// jours réellement renseignés (présents dans `parJour`).
// → { p1, p2, total, pourcentP1, pourcentP2, nonRenseignes }
export function calculerRepartition(parJour, debut, fin) {
  let p1 = 0, p2 = 0, nonRenseignes = 0;
  const cur = new Date(debut + 'T00:00:00');
  const last = new Date(fin + 'T00:00:00');
  while (cur <= last) {
    const g = parJour?.[dk(cur)];
    if (g === 'parent1') p1++;
    else if (g === 'parent2') p2++;
    else nonRenseignes++;
    cur.setDate(cur.getDate() + 1);
  }
  const total = p1 + p2;
  const pourcentP1 = total ? Math.round((p1 / total) * 100) : 0;
  const pourcentP2 = total ? 100 - pourcentP1 : 0;
  return { p1, p2, total, pourcentP1, pourcentP2, nonRenseignes };
}

// Répartition mois par mois → [{ cle:'2026-06', p1, p2, total }], triée.
// Pas de libellé de mois ici (module pur, sans i18n) : l'écran le calcule.
export function repartitionParMois(parJour, debut, fin) {
  const buckets = {};
  const cur = new Date(debut + 'T00:00:00');
  const last = new Date(fin + 'T00:00:00');
  while (cur <= last) {
    const cle = `${cur.getFullYear()}-${pad(cur.getMonth() + 1)}`;
    if (!buckets[cle]) buckets[cle] = { cle, mois: cur.getMonth(), p1: 0, p2: 0, total: 0 };
    const g = parJour?.[dk(cur)];
    if (g === 'parent1') { buckets[cle].p1++; buckets[cle].total++; }
    else if (g === 'parent2') { buckets[cle].p2++; buckets[cle].total++; }
    cur.setDate(cur.getDate() + 1);
  }
  return Object.values(buckets).sort((a, b) => a.cle.localeCompare(b.cle));
}
